
import { Injectable } from '@angular/core';
import { SharedModule } from '../shared/shared.module';

@Injectable({
    providedIn: SharedModule
})
export class StorageService {
    constructor() {}

    setItem(key: string, value: any) {
        localStorage.setItem(key, value);
    }

    getItem(key: string, defaultValue?: any) {
        const storedValue = localStorage.getItem(key);
        return storedValue ? storedValue : defaultValue;
    }

    removeItem(key: string) {
        localStorage.removeItem(key);
    }

    clearItem() {
        localStorage.clear();
    }
}
